import React from "react"

export const EmptyCard = ({children}) => {
    return (
        <div className="empty-card t-s4">
            {children}
        </div>
    )
}
